module.exports = __webpack_public_path__ + "img/matrix1.5877c9e0.png";